import React from "react";
import { useTranslation } from "react-i18next";

import { getMimeType } from "@components/getFileMimeType";
import { Templates } from "./templates";
import { FolderSelection } from "./folderSelection";
import { Name } from "./name";
import { Props } from "./types";
import styles from "./styles.scss";

function Form({
  documentType,
  isRequestPending,
  namespace,
  type,
  projectName,
  templates,
  selectedTemplate,
  selectedFolder,
  setDocumentName,
  setSelectedTemplate,
  setSelectedFolder,
}: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.form}>
      <Name setDocumentName={setDocumentName} />
      <div className={styles.folderSelection}>
        <p className={styles.name}>
          {t("documentCreation.folderSelection.title")}
        </p>
        <FolderSelection
          namespace={namespace}
          type={type}
          selectedFolder={selectedFolder}
          placeholder={t("moveDocument.placeholder")}
          projectName={projectName}
          select={(folder) => setSelectedFolder(folder)}
        />
      </div>
      <Templates
        templates={templates.filter(
          (document) => document.mimeType === getMimeType(documentType),
        )}
        isRequestPending={isRequestPending}
        selectedTemplate={selectedTemplate}
        setSelectedTemplate={setSelectedTemplate}
      />
    </div>
  );
}

export { Form };
